import { TunaDialog, DialogContent, DialogActions } from '../primitives/dialog.js'
import { Button } from '../primitives/button.js'
import type { FC, MouseEvent } from 'react'
import React, { useId } from 'react'
import { DialogTitle } from './dialog-title.js'
import moduleStyles from './dialog.module.css'

export interface CDialogProps {
  className?: string
  open: boolean
  controls?: React.ReactNode
  showClose?: boolean
  closeText?: string
  title?: string
  showOK?: boolean
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
  fullWidth?: boolean
  fullScreen?: boolean
  children?: React.ReactNode
  style?: React.CSSProperties
  onClick?: (ev: MouseEvent) => void
  onClose(ev?: MouseEvent): void
  onOK?(ev: MouseEvent): void
}

export const Dialog: FC<CDialogProps> = ({
  className,
  children,
  open,
  controls = null,
  onClose,
  closeText = 'Close',
  title,
  showClose = false,
  showOK = false,
  onOK,
  maxWidth,
  fullWidth,
  fullScreen,
  style,
  onClick,
}) => {
  const titleId = useId()
  if (!open) {
    return null
  }

  const showActions = showOK || showClose

  return (
    <TunaDialog
      open={open}
      className={className}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullScreen={fullScreen}
      style={style}
      aria-labelledby={title ? titleId : undefined}
    >
      {title ? (
        <DialogTitle onClose={onClose} id={titleId} controls={controls}>
          {title}
        </DialogTitle>
      ) : null}
      <DialogContent className={moduleStyles.dialogContent} onClick={onClick}>
        {children}
      </DialogContent>
      {showActions ? (
        <DialogActions>
          {showOK && <Button onClick={onOK}>OK</Button>}
          {showClose && <Button onClick={onClose}>{closeText}</Button>}
        </DialogActions>
      ) : null}
    </TunaDialog>
  )
}

export default Dialog
